import { render } from "./App.vue?vue&type=template&id=02b05454&bindings={\"scenarios\":\"data\",\"scenario\":\"data\",\"auto\":\"data\",\"values\":\"data\",\"setAuto\":\"options\",\"getScenario\":\"options\",\"calculateData\":\"options\",\"setScenario\":\"options\",\"setValue\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script